<template>
  <div class="bg-gray-300 p-6 w-full">
    <form >
      <div class="flex">
        <div class="mr-2 w-1/2">
          <input
            :placeholder="$t('sepa.firstname')"
            class="py-1 pl-2 outline-none w-full"
            :aria-label="$t('sepa.firstname')"
            v-model="owner.firstname"
            required  >

        </div>
        <div class=" w-1/2">
          <input
            :placeholder="$t('sepa.lastname')"
            class="py-1 pl-2 outline-none w-full"
            :aria-label="$t('sepa.lastname')"
            v-model="owner.lastname"
            required  >
        </div>

      </div>

      <div class="form-row">
        <div id="iban-element" ref="iban" aria-label="iban"
          class="bg-white p-2 mt-4 w-full" @change="displayErrors($event)">
          <!-- A Stripe Element will be inserted here. -->
        </div>
      </div>
      <div id="error-message" class="italic text-b2c-red-300 text-sm"> {{errorMessage}}</div>

    </form>
    <div class="flex justify-center">
      <button id="card-button" class="shadow-lg px-4 py-2 mt-4
      bg-white hover:text-white hover:bg-beige-academy-300 rounded
      hover:border-beige-academy-300"
        :class="isLoading ? 'loader' : ''" @click="saveIban()">
          {{ $t('sepa.save')}}
      </button>
    </div>
    <div id="mandate-acceptance" class="text-xs pt-2">
      By providing your IBAN and confirming this payment, you authorise <br>
      (A) E-Cademy Music and Stripe, our payment service
      provider, to send instructions to your bank to debit your account and <br>
      (B) your bank to debit your account in accordance with those instructions.
      You are entitled to a refund from your bank under the terms and
      conditions of your agreement with your bank. A refund must be claimed
      within 8 weeks starting from the date on which your account was debited.
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import { getStudentSetupIntent } from '@/services/PaymentService';

// eslint-disable-next-line no-undef
const stripe = Stripe(process.env.VUE_APP_STRIPE_KEY);
let iban = {};

export default {

  data() {
    return {
      owner: {
        firstname: '',
        lastname: '',
        email: '',
      },

      isLoading: false,

      errorMessage: '',

      options: {
        supportedCountries: ['SEPA'],
        placeholderCountry: this.$i18n.locale.toUpperCase(),
      },
    };
  },

  computed: {
    ...mapGetters({
      user: ['auth/user'],
      student: ['auth/student'],
    }),

  },

  mounted() {
    this.displayIban();

    this.owner.email = this.user.email;

    iban.on('change', (event) => {
      this.displayErrors(event);
    });
  },

  beforeDestroy() {
    iban.destroy(this.$refs.iban);
  },

  methods: {
    displayErrors(event) {
      if (event.error) {
        this.errorMessage = event.error.message;
      }
    },

    displayIban() {
      const elements = stripe.elements({
        locale: this.$i18n.locale,
      });
      iban = elements.create('iban', this.options);

      iban.mount(this.$refs.iban);
    },

    saveIban() {
      this.isLoading = true;
      getStudentSetupIntent(this.student.id).then(({ data }) => {
        stripe.confirmSepaDebitSetup(
          data.client_secret,
          {
            payment_method: {
              sepa_debit: iban,
              billing_details: {
                name: `${this.owner.firstname} ${this.owner.lastname}`,
                email: this.owner.email,
              },
            },
          },
        ).then((result) => {
          if (result.error) {
            this.isLoading = false;
            this.createNotification('error', result.error.message);
            return;
          }
          axios.post(`/api/students/${this.student.id}/update-payment-method`, { stripe_id: result.setupIntent.payment_method, type: 'sepa' }).then(() => {
            this.$emit('updated-payment-method');
            this.isLoading = false;
          }).catch((error) => {
            this.isLoading = false;
            this.checkSessionErrorNotification(error);
          });
        });
      });
    },
  },
};
</script>
